import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tb__right"
}
const _hoisted_2 = {
  key: 0,
  class: "tb__user-wrap"
}
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "tb__label" }
const _hoisted_5 = {
  key: 0,
  class: "tb__menu"
}
const _hoisted_6 = { class: "tb__menu-head" }
const _hoisted_7 = { class: "tb__menu-name" }
const _hoisted_8 = {
  key: 0,
  class: "tb__menu-dep"
}
const _hoisted_9 = {
  key: 1,
  class: "tb__menu-email"
}
const _hoisted_10 = ["href"]

import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import LifeBridge from '@tnlife/tn-bridge';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheTopbar',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const me = computed(() => authStore.me);
const loading = computed(() => authStore.loading);
const menuOpen = ref(false);
const isMiniApp = LifeBridge.isWebView || LifeBridge.isIFrame;

const initials = computed(() => {
  const n = me.value?.fullName || '';
  return n
    .split(/[\s·]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
});

const loginUrl = computed(
  () => `/auth/login?return=${encodeURIComponent(route.fullPath)}`
);

function closeMenu(): void {
  menuOpen.value = false;
}

async function handleLogout(): Promise<void> {
  closeMenu();
  await authStore.logout();
  router.push({ name: 'forms' });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TNUserPicture = _resolveComponent("TNUserPicture")!
  const _component_TNIcon = _resolveComponent("TNIcon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["tb", { 'tb--miniapp': _unref(isMiniApp) }])
  }, [
    _createVNode(_component_router_link, {
      to: { name: 'forms' },
      class: "tb__logo"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "tb__name" }, [
          _createElementVNode("b", null, "Опросы")
        ], -1)
      ]))]),
      _: 1
    }),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tb__spacer" }, null, -1)),
    (!_unref(isMiniApp))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (me.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  type: "button",
                  class: "tb__user",
                  "aria-expanded": menuOpen.value,
                  "aria-label": "Меню пользователя",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (menuOpen.value = !menuOpen.value))
                }, [
                  _createVNode(_component_TNUserPicture, {
                    text: initials.value,
                    size: "m",
                    square: true,
                    class: "tb__avatar-pic"
                  }, null, 8, ["text"]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(me.value.fullName), 1),
                  _createVNode(_component_TNIcon, {
                    name: "down-s",
                    size: 14,
                    class: "tb__caret"
                  })
                ], 8, _hoisted_3),
                (menuOpen.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(me.value.fullName), 1),
                        (me.value.department)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(me.value.department), 1))
                          : _createCommentVNode("", true),
                        (me.value.email)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(me.value.email), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tb__menu-sep" }, null, -1)),
                      _createElementVNode("button", {
                        class: "tb__menu-item",
                        type: "button",
                        onClick: handleLogout
                      }, [
                        _createVNode(_component_TNIcon, {
                          name: "backto",
                          size: 15
                        }),
                        _cache[2] || (_cache[2] = _createTextVNode(" Выйти ", -1))
                      ])
                    ])), [
                      [_directive_click_outside, closeMenu]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : (!loading.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "tb__login-link",
                  href: loginUrl.value
                }, "Войти", 8, _hoisted_10))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})